<template>
  <div>
    <div class="d1 lp">
      改写结果示例
      <span
        >(说明：通过调整句型、词汇来进行智能原创，提取首段内容效果如下)</span
      >
    </div>
    <div
      class="lp"
      v-for="(item, i) in resultMsg"
      :key="i"
      v-loading="item.loading"
    >
      <div class="lspan" style="font-size: 12px">
        <div
          class="tabs-box"
          style="    display: -webkit-box;display: -ms-flexbox;display: flex;line-height: 28px;font-size: 12px;"
        >
          <div style="flex: 1">
            <ul
              class="tabs"
              style="    margin-right: 10px;
    display: table;
    -webkit-box-shadow: none;
    box-shadow: none;
    width: auto;"
            >
              <li
                style="border:1px solid #DCDFE6;border-bottom:none;padding: 0 20px;
    position: relative;
    bottom: -1px;
    background-color: #fff;
    border-radius: 4px 4px 0 0;
    border-bottom-style: none;
    border: 1px solid #c3c9d2;
    border-bottom: none;"
              >
                {{
                  i === 0
                    ? "文风流畅改写"
                    : i === 1
                    ? "谨慎句式改写"
                    : i === 2
                    ? "轻度句式改写"
                    : "中度句式改写"
                }}
              </li>
            </ul>
          </div>

          <div>
            <button
              class="btn"
              @click="sendMsg(i == 0 ? 3 : i == 1 ? 2 : 1)"
              style="right:0;bottom:5px;padding:0 .5em;border-radius: 3px;"
            >
              选用该模型改写
            </button>
          </div>
        </div>
        <el-input
          style="position: initial;border-radius: 0 4px 4px 4px;"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5 }"
          v-model="item.value"
          resize="none"
          readonly
        ></el-input>
        <button class="btn_inner">相似度：{{ item.like }}%</button>
      </div>
    </div>
    <!-- <div class="lp center mt15">
      <button :class="[sending ? 'btn3' : 'btn']" @click="sendMsg()">
        开始智能改写
      </button>
      <button v-if="sending" class="btn2" @click="clearMsg()">取消操作</button>
    </div> -->
  </div>
</template>

<script>
import { RestructureModel } from "../../assets/script/model/index";
import { SendPostData } from "../../assets/script/model";
import { mapActions } from "vuex";
export default {
  name: "GetReinvent",
  data() {
    return {
      sending: false,
      resultMsg: [
        new RestructureModel(0, "", true),
        new RestructureModel(0, "", true),
        new RestructureModel(0, "", true)
      ],
      backMsg: false
    };
  },
  watch: {
    resultMsg(newval) {
      newval ? (this.backMsg = true) : (this.backMsg = false);
    }
  },
  mounted() {
    this.listenMessage();
  },
  beforeDestroy() {
    this.$messenger.clear();
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      this.getDemo(1);
      this.getDemo(2);
      this.getDemo(3);
      let that = this;
      this.$messenger.listen("akeydemo", e => {
        let getMsg = e.data.Data;
        if (getMsg) {
          //i==0?3:i==1?2:1
          if (getMsg.Type == 3) {
            that.resultMsg[0].value = getMsg.RestructureTxt; // getMsg.RestructureTxt
            that.resultMsg[0].like = that.fiter(getMsg.Like);
            that.resultMsg[0].loading = false;
          } else if (getMsg.Type == 2) {
            that.resultMsg[1].value = getMsg.RestructureTxt; //getMsg.RestructureTxt
            that.resultMsg[1].like = that.fiter(getMsg.Like);
            that.resultMsg[1].loading = false;
          } else if (getMsg.Type == 1) {
            that.resultMsg[2].value = getMsg.RestructureTxt; // getMsg.RestructureTxt
            that.resultMsg[2].like = that.fiter(getMsg.Like);
            that.resultMsg[2].loading = false;
          }
        }
      });
      this.$messenger.listen("restructure", () => {
        that.sending = false;
      });
      this.$messenger.listen("cancel", () => {
        that.sending = false;
      });

      // window.addEventListener("message", function(e) {
      //   if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
      //     // if (!e.data.isclose && e.data.btn === "akeydemo") {
      //     //   let getMsg = e.data.data.Data;
      //     //   if (getMsg) {
      //     //     that.resultMsg = getMsg.RestructureTxt;
      //     //     that.likeNumber = that.fiter(getMsg.Like);
      //     //   }
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "restructure") {
      //     //   that.sending = false;
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "cancel") {
      //     //   that.sending = false;
      //     // }
      //   }
      // });
    },
    async sendMsg(type) {
      let result = await this.APermission({ SysName: "wycakeyanalyze" });
      if (result.errorCode > 0) {
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        if (this.sending === false) {
          this.sending = true;
          let sendData = new SendPostData();
          sendData.btn = "restructure";
          sendData.data = {
            type: type
          };
          this.sendNewMsg(sendData.btn, sendData.data);
          // this.SendMessage(sendData);
        } else {
          this.$message({
            message: "正在句式重构中...",
            type: "warning"
          });
        }
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        // this.$message({
        //   message: "您的句式重构次数已用尽",
        //   type: "error",
        //   showClose: true
        // });
        this.sending = false;
      }
    },
    getDemo(type) {
      let sendData = new SendPostData();
      sendData.btn = "akeydemo";
      sendData.data = { type: type, notReplace: "", corewords: "" };
      this.sendNewMsg(sendData.btn, sendData.data);
    },
    clearMsg() {
      this.sending = false;
    },
    fiter(number) {
      let getNumber = 0;
      getNumber = (number * 100).toFixed(2);
      if (getNumber === "100.00") getNumber = 100;
      return getNumber;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
* {
  font-size: 13px;
}
.d1 {
  line-height: 30px;
  display: inline-block;
  span {
    color: #eeb733;
    font-size: 12px;
  }
}
.lp {
  padding: 5px 15px;
}
.btn {
  .btn();
  padding: 6px 15px;
}
.btn2 {
  .btn();
  background-color: #bfbfbf;
  border: 0;
  padding: 7px 30px;
}
.btn3 {
  .btn();
  padding: 7px 15px;
  background-color: #b7cdfc;
  border: 0;
}
.lspan {
  background-color: @boxback-color;
  line-height: 30px;
  padding: 10px 10px;
  border-radius: 5px;
  height: 158px;
}
/deep/.lspan .el-textarea__inner {
  border-radius: 0 4px 4px 4px;
  outline: none;
  border: solid 0px;
  outline: none;
  border: 1px solid rgb(195, 201, 210);
}
</style>
